module.exports = __webpack_public_path__ + "static/media/Scout-1-Secret-of-the-Swamp-2020-s.9b5f8607.jpg";